import api from "service/api";

export function login(data) {
  return api.post("/user/login", data);
}

export function forgotPassword(data) {
  return api.post(`/auth/forgot-password`, data);
}

export function verifyOTP(data) {
  return api.post(`/auth/verify-otp`, data);
}

export function resetPassword(data) {
  return api.post(`/auth/reset-password`, data);
}

export function checkSetup() {
  return api.get("/setup/check");
}

export function setupSuperAdmin(data) {
  return api.post("/setup/superadmin", data);
}
